/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Method_Bank_TransferInputs */

const vi_cashflow_method_bank_transfer = /** @type {(inputs: Cashflow_Method_Bank_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển khoản`)
};

/**

* @param {Cashflow_Method_Bank_TransferInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_method_bank_transfer = /** @type {((inputs?: Cashflow_Method_Bank_TransferInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Method_Bank_TransferInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_method_bank_transfer(inputs)
});